import { render } from "./Index.vue?vue&type=template&id=015b36af"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "015b36af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('015b36af', __exports__)) {
    console.log('reload')
    api.reload('015b36af', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=015b36af", () => {
    console.log('re-render')
    api.rerender('015b36af', render)
  })

}


export default __exports__